export enum PanningAxis {
  Both = 'both',
  Horizontal = 'horizontal',
  Vertical = 'vertical',
}